import { getServicesData } from './servicesData';

const CITIES = [
  // Vaucluse (84)
  { name: 'Sainte-Cécile-les-Vignes', slug: 'sainte-cecile-les-vignes', dept: 'Vaucluse (84)', cp: '84290', distance: 0 },
  { name: 'Orange', slug: 'orange', dept: 'Vaucluse (84)', cp: '84100', distance: 10 },
  { name: 'Avignon', slug: 'avignon', dept: 'Vaucluse (84)', cp: '84000', distance: 35 },
  { name: 'Carpentras', slug: 'carpentras', dept: 'Vaucluse (84)', cp: '84200', distance: 28 },
  { name: 'Cavaillon', slug: 'cavaillon', dept: 'Vaucluse (84)', cp: '84300', distance: 55 },
  { name: 'Apt', slug: 'apt', dept: 'Vaucluse (84)', cp: '84400', distance: 60 },
  { name: 'Bollène', slug: 'bollene', dept: 'Vaucluse (84)', cp: '84500', distance: 15 },
  { name: 'Sorgues', slug: 'sorgues', dept: 'Vaucluse (84)', cp: '84700', distance: 22 },
  { name: 'Monteux', slug: 'monteux', dept: 'Vaucluse (84)', cp: '84170', distance: 22 },
  { name: "L'Isle-sur-la-Sorgue", slug: 'isle-sur-la-sorgue', dept: 'Vaucluse (84)', cp: '84800', distance: 40 },
  { name: 'Vaison-la-Romaine', slug: 'vaison-la-romaine', dept: 'Vaucluse (84)', cp: '84110', distance: 18 },
  { name: 'Le Pontet', slug: 'le-pontet', dept: 'Vaucluse (84)', cp: '84130', distance: 28 },
  { name: 'Pernes-les-Fontaines', slug: 'pernes-les-fontaines', dept: 'Vaucluse (84)', cp: '84210', distance: 30 },
  // Gard (30)
  { name: 'Nîmes', slug: 'nimes', dept: 'Gard (30)', cp: '30000', distance: 60 },
  { name: 'Bagnols-sur-Cèze', slug: 'bagnols-sur-ceze', dept: 'Gard (30)', cp: '30200', distance: 18 },
  { name: 'Uzès', slug: 'uzes', dept: 'Gard (30)', cp: '30700', distance: 45 },
  { name: 'Villeneuve-lès-Avignon', slug: 'villeneuve-les-avignon', dept: 'Gard (30)', cp: '30400', distance: 35 },
  // Drôme (26)
  { name: 'Montélimar', slug: 'montelimar', dept: 'Drôme (26)', cp: '26200', distance: 50 },
  { name: 'Nyons', slug: 'nyons', dept: 'Drôme (26)', cp: '26110', distance: 35 },
  { name: 'Pierrelatte', slug: 'pierrelatte', dept: 'Drôme (26)', cp: '26700', distance: 25 },
  // Bouches-du-Rhône (13)
  { name: 'Arles', slug: 'arles', dept: 'Bouches-du-Rhône (13)', cp: '13200', distance: 60 },
  { name: 'Tarascon', slug: 'tarascon', dept: 'Bouches-du-Rhône (13)', cp: '13150', distance: 45 },
  { name: 'Saint-Rémy-de-Provence', slug: 'saint-remy-de-provence', dept: 'Bouches-du-Rhône (13)', cp: '13210', distance: 45 },
  { name: 'Châteaurenard', slug: 'chateaurenard', dept: 'Bouches-du-Rhône (13)', cp: '13160', distance: 35 },
];

export const getLocalLandingData = () => {
  const services = getServicesData('fr');
  const pages = [];

  services.forEach(service => {
    CITIES.forEach(city => {
      pages.push({
        slug: `${service.slug}-${city.slug}`,
        service,
        city,
      });
    });
  });

  return pages;
};

export const findLandingPage = (slug) => {
  const pages = getLocalLandingData();
  return pages.find(p => p.slug === slug) || null;
};

export const getCitiesByDept = () => {
  const depts = {};
  CITIES.forEach(city => {
    if (!depts[city.dept]) depts[city.dept] = [];
    depts[city.dept].push(city);
  });
  return depts;
};

export { CITIES };
